import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
import AttachmentItemsSort from 'owa-service/lib/contract/AttachmentItemsSort';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import datapoints from '../datapoints';
import GetFileProviderItemsResponse from '../types/GetFileProviderItemsResponse';
import getFileProviderItemsService from '../utils/getOrSearchFileProviderItems/getFileProviderItems';
import TokenResponseCode from 'owa-service/lib/contract/TokenResponseCode';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { isTokenRetrievalError } from 'owa-fileprovider-items-service';

// FPGetItems has customData that is called on the getFileProviderItems input parameters.
// If you change the input params make sure to update FPGetItems in datapoints.ts to match.

/**
 * If an error is encountered and the promise is broken we throw an AttachmentResultCode that is handled by the caller.
 */
export default createLegacyActionWithDatapoint('getFileProviderItems', datapoints.FPGetItems)(
    async function getFileProviderItems(
        fileProviderType: AttachmentDataProviderType,
        fileProviderId: string,
        offset: number,
        filterBy: AttachmentItemsFilterBy = AttachmentItemsFilterBy.None,
        scope: AttachmentDataProviderScope = null,
        fileProviderEndpointUrl: string = null,
        folderId?: string,
        location?: string,
        pagingMetadata: AttachmentItemsPagingMetadata = null,
        sort?: AttachmentItemsSort
    ): Promise<GetFileProviderItemsResponse> {
        try {
            return await getFileProviderItemsService(
                fileProviderType,
                fileProviderId,
                offset,
                filterBy,
                scope,
                fileProviderEndpointUrl,
                folderId,
                location,
                pagingMetadata,
                sort
            );
        } catch (error) {
            if (isTokenRetrievalError(error)) {
                if (error.resultCode === TokenResponseCode.Unauthorized) {
                    // If the error is a token response code unauthorized then it is similar
                    // to the Access denied error code from AttachmentResultCode
                    throw AttachmentResultCode.AccessDenied;
                }
            }

            // Otherwise rethrow
            throw error;
        }
    }
);
